import { useEffect, useCallback } from "react";
import Button from "./controls/button";
import { useAppDispatch } from "../hooks/useAppDispatch";
import { useAppSelector } from "../hooks/useAppSelector";
import {
    fetchWhatsappSetting,
    integrateWhatsapp,
    setEmbeddedCode,
    setLoginDetails,
} from "../store/features/organisation/whatsapp-slice";

declare global {
    interface Window {
        fbAsyncInit: () => void;
        FB: any;
    }
}

export default function WhatsAppSignup() {
    const { integrated, phoneNumberId, wabaId, embeddedCode, loading } = useAppSelector((state) => state.whatsApp);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (phoneNumberId && wabaId && embeddedCode) {
            dispatch(integrateWhatsapp({
                phoneNumberId,
                wabaId,
                embeddedCode
            }));
        }
    }, [phoneNumberId, wabaId, embeddedCode])

    // Load the Facebook SDK once
    useEffect(() => {
        if (window.FB) return; // already loaded

        window.fbAsyncInit = function () {
            window.FB.init({
                appId: "936486112021432",
                autoLogAppEvents: true,
                xfbml: true,
                version: "v23.0",
            });
        };

        const id = "facebook-jssdk";
        if (!document.getElementById(id)) {
            const js = document.createElement("script");
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            js.async = true;
            js.defer = true;
            const fjs = document.getElementsByTagName("script")[0];
            fjs?.parentNode?.insertBefore(js, fjs);
        }

        const handleMessage = (event: MessageEvent) => {
            if (!event.origin.endsWith("facebook.com")) return;
            try {
                const data = JSON.parse(event.data);
                if (data.type === "WA_EMBEDDED_SIGNUP" && data.event === "FINISH") {
                    const { phone_number_id, waba_id } = data.data;
                    dispatch(setLoginDetails({ wabaId: waba_id, phoneNumberId: phone_number_id }));
                }
            } catch (err) {
                console.warn("Unexpected message event:", event.data);
            }
        };

        window.addEventListener("message", handleMessage);
        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, [dispatch]);

    useEffect(() => {
        dispatch(fetchWhatsappSetting());
    }, [])

    // Handle FB login callback
    const fbLoginCallback = (response: any) => {
        if (response.authResponse?.code) {
            dispatch(setEmbeddedCode(response.authResponse?.code));
        } else {
            console.warn("FB login response:", response);
        }
    };

    const launchWhatsAppSignup = () => {
        if (integrated) return;
        if (!window.FB) {
            console.error("Facebook SDK not loaded yet.");
            return;
        }

        window.FB.login(fbLoginCallback, {
            config_id: "730485049451702",
            response_type: "code",
            override_default_response_type: true,
            extras: {
                setup: {},
                featureType: "",
                sessionInfoVersion: "3",
            },
        });
    }

    return (
        <Button
            id="whatsAppSignup"
            loading={loading}
            variant={integrated ? "outlined" : "contained"}
            onClick={launchWhatsAppSignup}
            label={integrated ? "Whatsapp Connected" : "Connect WhatsApp"}
        />
    );
}
